import React from 'react';
import { TouchableOpacity, View, Text, StyleSheet, Platform, Dimensions } from 'react-native';
import CS from '../constants/Styles';
import Colors from '../constants/Colors';
import { Ionicons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import { Video } from 'expo-av';
import * as WebBrowser from 'expo-web-browser';

export default function PlayVideoButton({ ...props }) {

  const windowWidth = Dimensions.get('window').width;
  const video = React.useRef(null);
  const [showVideo, setShowVideo] = React.useState(false);
  const [status, setStatus] = React.useState({});
  const [videoWebStyle, setVideoWebStyle] = React.useState({});

  React.useEffect(() => {
    setVideoWebStyle(videoStyle(windowWidth));
    if (Platform.OS === 'web') {
      const subscription = Dimensions.addEventListener('change', onChangeDimensions);
      return () => {
        // Dimensions.removeEventListener('change', onChangeDimensions);
        subscription.remove();
      }
    }

    // return () => {
    //   video.current.unloadAsync();
    // }
  }, []);

  const onChangeDimensions = ({ window, screen }) => {
    console.log('onChangeDimensions');
    // setLogoWebStyle(logoStyle(window.width));
    setVideoWebStyle(videoStyle(window.width));
  };

  const playVideo = async () => {
    console.log('play video');
    if(Platform.OS !== 'web'){
      if (showVideo) {
        if (status.isPlaying) {
          video.current.stopAsync()
        } else {
          video.current.playAsync()
        }
      }
    }
    setShowVideo(true);
    if (props.scrollRef) {
      setTimeout(() => {
        props.scrollRef.current.scrollToEnd({ animated: true });
      }, 500)
    }
  }
  const updateStatus = (status) => {
    // console.log('updateStatus: ', status);
    setStatus(status);
    if (status.didJustFinish) {
      console.log('justFinished');
      video.current.stopAsync();
      // setShowVideo(false); // causes error for some reason
    }
  }

  const videoStyle = (windowWidth) => {
    const ratio = 1080 / 1920;
    if (Platform.OS === 'web') {
      const width = (windowWidth > 748) ? 748 : windowWidth - 20;
      console.log('videoStyle: ', {
        width: width,
        height: width * ratio,
      })
      return {
        width: width,
        height: width * ratio,
      }
    }
    return {}
  }

  const getColors = () => {
    if (Platform.OS === 'web') {
      return [Colors.blue3, Colors.lightBlue, Colors.blue3];
    }
    return [Colors.blue, Colors.blue2, Colors.blue];
  }
  const getStart = () => {
    if(Platform.OS === 'web'){
      return { x: 0.5, y: 0.5 };
    }
    return { x: 0.25, y: 0.25 };
  }
  const getLocations = () => {
    if (Platform.OS === 'web') {
      return [0.25, 0.5, 0.75];
    }
    return [0, 0.5, 1];
  }

  const videoContent = () => {
    if(!showVideo){ return null; }
    if(Platform.OS === 'web'){
      return (
        <View style={{ alignItems: 'center', borderRadius: 10, borderWidth: 1, borderColor: Colors.lightBlue2, overflow: 'hidden' }}>
          <iframe
            // width="560"
            // height="315"
            width={videoWebStyle.width}
            height={videoWebStyle.height}
            src={`https://www.youtube.com/embed/${props.youtube}?autoplay=1`}
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
            ></iframe>
        </View>
      )
    }else{
      return (
        <Video
          ref={video}
          style={[styles.video, videoWebStyle]}
          source={{
            uri: props.source,
          }}
          useNativeControls
          resizeMode="contain"
          onPlaybackStatusUpdate={status => updateStatus(status)}
          onLoad={() => { video.current.playAsync() }}
        />
      )
    }
  }
  
  return (
    <>
      <View style={props.outerContainerStyle && props.outerContainerStyle}>
        <TouchableOpacity activeOpacity={0.6} onPress={playVideo}>
          <LinearGradient
            // Button Linear Gradient
            colors={getColors()}
            style={styles.playVideoButton}
            start={getStart()}
            locations={getLocations()}
          >
            <LinearGradient
              // Background Linear Gradient
              colors={['transparent', Colors.blue3]}
              style={styles.gradient2}
            />
            <Ionicons name="play-circle" size={42} color={Colors.yellow} style={styles.icon} />
            <Text style={[CS.lightText, CS.smallText, CS.capsLock, CS.boldText, styles.text]}>{props.text}</Text>
            {props.length ?
              <Text style={[CS.lightText, CS.miniText]}>{props.length}</Text>
            : null}
          </LinearGradient>
        </TouchableOpacity>
      </View>
      {videoContent()}
      {/* {
        showVideo &&
        <Video
          ref={video}
          style={[styles.video, videoWebStyle]}
          source={{
            uri: props.source,
          }}
          useNativeControls
          resizeMode="contain"
          onPlaybackStatusUpdate={status => updateStatus(status)}
          onLoad={() => { video.current.playAsync() }}
        />
      } */}
    </>
  )

}

const styles = StyleSheet.create({
  playVideoButton: {
    borderColor: Colors.lightBlue,
    borderWidth: 1,
    borderRadius: 10,
    padding: 10,
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginRight: 5,
    zIndex: 1,
  },
  text: {
    zIndex: 1,
    marginRight: 20,
    flex:1
  },
  gradient2: {
    position: 'absolute',
    left: 0,
    
    top: 0,
    height: '100%',
    borderRadius: 10,
    ...Platform.select({
      web: {
        right: 0,
      }
    })
  },
  video: {
    alignSelf: 'center',
    width: '100%',
    height: 'auto',
    maxWidth: 768,
    maxHeight: 432,
    marginBottom: 20,
    borderRadius: 10,
    borderColor: Colors.lightBlue,
    borderWidth: 1,
    ...Platform.select({
      ios: {
        aspectRatio: 1920 / 1080,
      },
      android: {
        aspectRatio: 1920 / 1080,
      },
    })
  },
});